import {Component, OnInit, ViewChild} from "@angular/core";
import {Field} from "../models/field.model";
import {SelectComponent} from "ng2-select-compat";
import {TranslateService} from '@ngx-translate/core';

@Component({
	selector: "tig-form-select-multiple",
	template: `
	<div
		class="form-group"
		[formGroup]="OBJ_form_group"
		[ngClass]="{'has-error': isInvalid()}">
		<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
		<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
			<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
				[tooltip]="tooltipTemplate"
				placement="top"
				triggers="click"
				containerClass="tig-tooltip"
				delay="50"></i>
            <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
		<div class="col-lg-8">
			<ng-select
				[formControlName]="OBJ_field_config.name"
				[items]="OBJ_field_config.options"
				[multiple]="(OBJ_field_config.multiple != null)?OBJ_field_config.multiple:true"
				[disabled]="OBJ_field_config?.readonly"
				(selected)="selected($event)"
				(removed)="removed($event)"
				(data)="refreshValue($event)"
				[placeholder]="'please_select'|translate"
				[allowClear]="true"
			></ng-select>
            <div *ngIf="STR_dependent_fields">{{ "oSelect.swarning_dependent_fields"|translate:{value:this.STR_dependent_fields} }}</div>
			<div class="tig-hint" *ngIf="OBJ_field_config.note">
				<span>{{ OBJ_field_config.note|translate}}</span>
			</div>
            <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
		</div>
	</div>
	`
})
export class FormSelectMultipleComponent extends Field implements OnInit
{

	/**
	 * static muss true sein, damit aenderung von textfield auf name greift - in AfterViewInit ist es bereits zu spaet
	 * vgl. hierzu: https://angular.io/guide/static-query-migration#should-i-use-static-true
	 */
	@ViewChild(SelectComponent, {static: true}) OBJ_select_component: SelectComponent;

	constructor(private OBJ_translate_service: TranslateService){
		super();
	}

	/**
	 * Function > ngAfterViewInit
	 */
	ngOnInit(): void
	{
		// change text-field from 'text' (default) to 'name'
		this.OBJ_select_component.textField = "name";
        this.getDependentFields(this.OBJ_translate_service);

	} // end function ngOnInit


	/**
	 * Function > selected
	 * @param {object} OBJ_selected_value
	 */
	public selected(OBJ_selected_value: {id:string, text:string}): void
	{

       let OBJ_value = {id:OBJ_selected_value.id, name:OBJ_selected_value.text};

		// Wenn multiple nicht oder auf true gesetzt ist, wird Wert immer einfach angehangen
		if (this.OBJ_field_config.multiple == null || this.OBJ_field_config.multiple)
		{
			this.OBJ_field_config.value.push(OBJ_value);
		}
		else
		{
			// Ansonsten simples Dropdown, Wert wird ersetzt
			this.OBJ_field_config.value = [ OBJ_value ];
		} // end if

		this.setValueManually();

	} // end function selected


	/**
	 * Function > removed
	 * @param {object} OBJ_removed_value
	 */
	public removed(OBJ_removed_value: {id:string, text:string}): void
	{

		// Entferne entsprechendes Element aus der Auswahl
        this.OBJ_field_config.value = this.OBJ_field_config.value.filter(OBJ_item => OBJ_item.id !== OBJ_removed_value.id);

        this.setValueManually();

    } // end function removed


	public refreshValue(ARR_values:any): void
	{

	} // end function refreshValue

	/**
	 * Function > setValueManually
	 *
	 * @desc Because value is not set automatically and dirty not updated we set this manually
	 */
	setValueManually()
	{
		let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);
		// set value of FormControl to trigger validation
		OBJ_form_control.setValue(this.OBJ_field_config.value);
		this.markAsDirtyAndTouched();
	} // end function setValueManually


} // end class FormSelectMultipleComponent
